<template>
  <section class="cta-banner">
    <div class="cta-inner">
      <div class="cta-content">
        <h2 class="cta-title">立即开始你的域名之旅</h2>
        <p class="cta-desc">免费注册，获取专属二级域名</p>
        <div class="cta-buttons">
          <a href="/user" class="cta-btn primary">立即使用</a>
          <a href="#announcements" class="cta-btn secondary">官方公告</a>
        </div>
      </div>
      <div class="cta-character">
        <img :src="ctaImage" alt="角色立绘" class="cta-character-img">
      </div>
    </div>
  </section>
</template>

<script setup>
import ctaImage from '../assets/image2.png'
</script>
